module.exports = __webpack_public_path__ + "media/ELLUS.9c5f66d0.mp4";